export const SET_CURRENT_COUNTRY_CODE = 'SET_CURRENT_COUNTRY_CODE';
export const SET_THANK_YOU_PAGE = 'SET_THANK_YOU_PAGE';
export const SET_LOADING = 'SET_LOADING';
